import { Locale } from "../UserData/_stores/UserPrefsStore"

const HELP_CENTER_URLS = {
  en_CA: {
    root: 'https://artofwhere.zendesk.com/hc/en-us',
    creatingProducts: 'https://artofwhere.zendesk.com/hc/en-us/sections/37974482603415-How-to-use-the-Design-Lab',
    storeIntegrations: 'https://artofwhere.zendesk.com/hc/en-us/sections/37974441327127-Dropshipping',
    printingBasics: 'https://artofwhere.zendesk.com/hc/en-us/sections/37974562907415-Print-methods',
    productionShipping: 'https://artofwhere.zendesk.com/hc/en-us/categories/37680445362071-Production-Shipping',
  },
  fr_CA: {
    root: 'https://artofwhere.zendesk.com/hc/fr-ca',
    creatingProducts: 'https://artofwhere.zendesk.com/hc/fr-ca/sections/37974482603415-Comment-utiliser-le-Design-Lab',
    storeIntegrations: 'https://artofwhere.zendesk.com/hc/fr-ca/categories/37621604126871-Pour-commencer',
    printingBasics: 'https://artofwhere.zendesk.com/hc/fr-ca/sections/37974562907415-M%C3%A9thodes-d-impression',
    productionShipping: 'https://artofwhere.zendesk.com/hc/fr-ca/categories/37680445362071-Production-et-exp%C3%A9dition',
  },
}

export type HelpCenterLinks = typeof HELP_CENTER_URLS[Locale]

export function getHelpCenterUrl(locale?: string | null) {
  return HELP_CENTER_URLS[locale === 'fr_CA' ? 'fr_CA' : 'en_CA'].root
}

export function getHelpCenterLinks(locale?: string | null): HelpCenterLinks {
  return HELP_CENTER_URLS[locale === 'fr_CA' ? 'fr_CA' : 'en_CA']
}
